/**
 * FAQ minimal centered — optional single-open accordion; safe with multiple script tags.
 */
(function () {
  document.querySelectorAll('[data-mfqc-root]').forEach(function (root) {
    if (root.getAttribute('data-mfqc-bound') === '1') return;
    root.setAttribute('data-mfqc-bound', '1');

    if (root.getAttribute('data-mfqc-single') !== 'true') return;

    root.querySelectorAll('details.mfqc__item').forEach(function (details) {
      details.addEventListener('toggle', function () {
        if (!details.open) return;
        root.querySelectorAll('details.mfqc__item').forEach(function (other) {
          if (other !== details) other.removeAttribute('open');
        });
      });
    });
  });
})();
